import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from './translations';
type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof translations.en;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
// Detect the browser language synchronously so the app can render on the
// very first paint — no blank/white screen while we "initialize".
const detectLanguage = (): Language => {
  if (typeof navigator !== 'undefined') {
    const browserLang = (navigator.language || '').toLowerCase();
    if (browserLang.startsWith('es')) return 'es';
  }
  return 'en';
};
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [language, setLanguage] = useState<Language>(detectLanguage);
  const t = translations[language];
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-185">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};